import clsx from 'clsx'

export function InstagramIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      className={clsx('text-[#5B5B5B]', className)}
      aria-hidden="true"
    >
      <path
        d="M19.5781 0.423828H8.68131C4.25277 0.423828 0.649902 4.0267 0.649902 8.45524V19.352C0.649902 23.7805 4.25277 27.3834 8.68131 27.3834H19.5781C24.0066 27.3834 27.6095 23.7805 27.6095 19.352V8.45524C27.6094 4.0267 24.0066 0.423828 19.5781 0.423828ZM24.8974 19.352C24.8974 22.2897 22.5158 24.6713 19.5781 24.6713H8.68131C5.74358 24.6713 3.36204 22.2897 3.36204 19.352V8.45524C3.36204 5.51746 5.74358 3.13596 8.68131 3.13596H19.5781C22.5158 3.13596 24.8974 5.51746 24.8974 8.45524V19.352Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M14.1294 6.93115C10.2847 6.93115 7.15674 10.0591 7.15674 13.9038C7.15674 17.7485 10.2847 20.8765 14.1294 20.8765C17.9742 20.8765 21.1022 17.7486 21.1022 13.9038C21.1022 10.0591 17.9742 6.93115 14.1294 6.93115ZM14.1294 18.1644C11.7764 18.1644 9.86887 16.2569 9.86887 13.9039C9.86887 11.5508 11.7764 9.64329 14.1294 9.64329C16.4825 9.64329 18.39 11.5508 18.39 13.9039C18.39 16.2569 16.4825 18.1644 14.1294 18.1644Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M21.1161 8.65411C22.0389 8.65411 22.7869 7.90606 22.7869 6.9833C22.7869 6.06055 22.0389 5.3125 21.1161 5.3125C20.1934 5.3125 19.4453 6.06055 19.4453 6.9833C19.4453 7.90606 20.1934 8.65411 21.1161 8.65411Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  )
}
